<template>
<div>
    <div style="margin-bottom:10px;">
        <table class="table2"border=0>
            <tr>
                <td style="width:85px;text-align:right;">Not achieved</td>
                <td style="background-color:#C5E0B4">&nbsp;</td>
                <td style="background-color:#F4B183">&nbsp;</td>
                <td style="background-color:#FFE699">&nbsp;</td>
                <td style="background-color:#FFFF00">&nbsp;</td>
                <td>Achieved</td>
            </tr>
        </table>
    </div>

    <table border=0 class="table1">
      <thead>
        <!--<tr>
          <th rowspan=2 colspan=1>开放包容发展层次</th>
          <th colspan=8>中国对应开放科学路线图</th>
        </tr>-->
        <tr>
          <th>Level</th>
          <th>Academic outputs</th>
          <th>International academic influence</th>
          <th>State owned journals</th>
          <th>Data platform</th>
          <th>Large scientific facility</th>
          <th>Policy system</th>
          <th>Policy influence</th>
          <th>Target year</th>
        </tr>
      </thead>
      <tbody>

<!--        <tr>
            <td><div>生理需要</div></div></td>
            <td><div style="display:none">我国可以立足于国际开放科学的大环境</div></td>
            <td class="td_normal"><div>与中国人口和研究人员的世界占比相适应</div></td>
            <td class="td_normal"><div>FWCI不低于世界平均水平</div></td>
            <td class="td_normal"><div>成规模地进入世界科学数据平台</div></td>
            <td class="td_normal"><div>启动培育计划</div></td>
            <td class="td_normal"><div>开始出现</div></td>
            <td class="td_normal"><div>适应开放科学建议书的政策要求</div></td>
            <td class="td_normal"><div>受到全球关注</div></td>
            <td class="td_normal"><div>现在</div></td>
        </tr>
        <tr>
            <td><div>安全需要</div></td>
            <td><div style="display:none">国际上开放科学的大环境下，我国科学家得到稳定、安全、有秩序、不间断的数据获取和数据服务保护</div></td>
            <td class="td_normal"><div>不低于世界的20%，与美、欧大致相当</div></td>
            <td class="td_normal"><div>FWCI高于世界平均水平</div></td>
            <td class="td_normal"><div>占据世界科学数据平台数据量的5%左右，形成机器语言翻译能力</div></td>
            <td class="td_normal"><div>形成世界上有显示度的代表性数据平台，初步形成数据安全能力（FAIR），可转接与中国关联（与中国作者有关的数据及已购置使用权的全球数据）</div></td>
            <td class="td_normal"><div>建成若干种世界上独有的科学大仪器平台</div></td>
            <td class="td_normal"><div>可为数据安全提供初步的国际法律与契约保证</div></td>
            <td class="td_normal"><div>形成具有全球博弈能力的政策</div></td>
            <td class="td_normal"><div>2025</div></td>
        </tr>
        <tr>
            <td><div>社会性需要</div></td>
            <td><div style="display:none">我国得以有效地融入国际开放科学的大环境</div></td>
            <td class="td_normal"><div>形成世界学术产出不可缺少的一级</div></td>
            <td class="td_normal"><div>FWCI接近美欧水平</div></td>
            <td class="td_normal"><div>在世界科学数据上占据一席之地</div></td>
            <td class="td_normal"><div>形成世界上具有竞争力的数据平台</div></td>
            <td class="td_normal"><div>成为世界科学大仪器平台中不可或缺的组成部分</div></td>
            <td class="td_normal"><div>形成可融入开放科学全球治理的政策体系</div></td>
            <td class="td_normal"><div>形成具有全球影响力的政策</div></td>
            <td class="td_normal"><div>2030</div></td>
        </tr>
        <tr>
            <td><div>尊重需要</div></td>
            <td><div style="display:none">中国在国际开放科学的大环境下建立其自身的尊严、成就、掌控、独立，地位、威望</div></td>
            <td class="td_normal"><div>与美欧并行</div></td>
            <td class="td_normal"><div>FWCI与美欧相当</div></td>
            <td class="td_normal"><div>在世界科学数据上受到全球科学家的尊重</div></td>
            <td class="td_normal"><div>形成世界数据平台不可或缺的部分</div></td>
            <td class="td_normal"><div>在世界科学大仪器平台中与美欧并行</div></td>
            <td class="td_normal"><div>贡献与联合国常任理事国地位相称的开放科学全球治理政策</div></td>
            <td class="td_normal"><div>成为美欧以外的另一极</div></td>
            <td class="td_normal"><div>2035</div></td>
        </tr>
        <tr>
            <td><div>自驱需要</div></td>
            <td><div style="display:none">得以推动国际开放科学的发展大局，成为全球知识共同体的领航人之一</div></td>
            <td class="td_normal"><div>形成世界学术产出的领跑一极</div></td>
            <td class="td_normal"><div>FWCI在世界领跑</div></td>
            <td class="td_normal"><div>成为世界科学数据的核心期刊群</div></td>
            <td class="td_normal"><div>成为数据平台强国</div></td>
            <td class="td_normal"><div>引领世界科学大仪器平台的发展</div></td>
            <td class="td_normal"><div>引领开放科学全球治理政策</div></td>
            <td class="td_normal"><div>成为全球的政策驱动极</div></td>
            <td class="td_normal"><div>2040-50</div></td>
        </tr>
-->

        <tr v-for="(v1,k1) in tableData" :class="'tr_'+k1">
            <template v-for="(v2, k2) in v1">
                <td v-if="k2==0"><div>{{v2}}</div></td>
                <!--<td v-if="k2==1"><div style="display:none">{{v2}}</div></td>-->

                <td v-if="k2==9"><div>{{v2}}</div></td>

                <td v-if="k2>1 && k2<9" class="td_normal"  @click="chgShowTableItem(k1,k2)" style="cursor:pointer;" :class="isHighlightTd(k1,k2)">
                    <div v-show="isShow(k1, k2)">
                        {{v2}}
                    </div>
                </td>
            </template>
        </tr>



        <tr>
            <td colspan=1><div>Dimension</div></td>
            <td colspan=3><div>Open access</div></td>
            <td colspan=2><div>Open data</div></td>
            <td colspan=2><div>Open science policy</div></td>
            <td colspan=1><div></div></td>
        </tr>


      </tbody>
    </table>
</div>
</template>



<script>

export default {
  name: 'table1',
  props: {
    avadata: Object,
    simpleavadata: Object,
    showDemo: String
  },
  data() {
    return {
      option : { },
      owndata : {},

      tableData : [
        ['Physiological needs', '我国可以立足于国际开放科学的大环境',
            '与中国人口和研究人员的世界占比相适应', 'FWCI不低于世界平均水平', '成规模地进入世界科学数据平台', '启动培育计划', '开始出现', '适应开放科学建议书的政策要求', '受到全球关注' ,''],
        ['Security needs', '国际上开放科学的大环境下，我国科学家得到稳定、安全、有秩序、不间断的数据获取和数据服务保护',
            '不低于世界的20%，与美、欧大致相当', 'FWCI高于世界平均水平', '占据世界科学数据平台数据量的5%左右，形成机器语言翻译能力', '形成世界上有显示度的代表性数据平台，初步形成数据安全能力（FAIR），可转接与中国关联（与中国作者有关的数据及已购置使用权的全球数据）',
            '建成若干种世界上独有的科学大仪器平台', '可为数据安全提供初步的国际法律与契约保证', '形成具有全球博弈能力的政策', '2025' ],
        ['Social needs', '我国得以有效地融入国际开放科学的大环境',
            '形成世界学术产出不可缺少的一级', 'FWCI接近美欧水平', '在世界科学数据上占据一席之地', '形成世界上具有竞争力的数据平台', '成为世界科学大仪器平台中不可或缺的组成部分', '形成可融入开放科学全球治理的政策体系', '形成具有全球影响力的政策', '2030' ],
        ['Respected needs', '中国在国际开放科学的大环境下建立其自身的尊严、成就、掌控、独立，地位、威望', 
            '与美欧并行', 'FWCI与美欧相当', '在世界科学数据上受到全球科学家的尊重', '形成世界数据平台不可或缺的部分', '在世界科学大仪器平台中与美欧并行', '贡献与联合国常任理事国地位相称的开放科学全球治理政策', '成为美欧以外的另一极', '2035' ],
        ['Self driving needs', '得以推动国际开放科学的发展大局，成为全球知识共同体的领航人之一',
            '形成世界学术产出的领跑一极', 'FWCI在世界领跑', '成为世界科学数据的核心期刊群', '成为数据平台强国', '引领世界科学大仪器平台的发展', '引领开放科学全球治理政策', '成为全球的政策驱动极', '2040-50' ],
      ],

      showX : 0,
      showY : 0,

    }
  },
  watch: {
    treemapdata: {
      handler(newValue, oldValue) {
        this.owndata = newValue
        this.getDataView()
      }
    }
  },
  mounted() {
    console.log('[table1/mounted]')
    this.$nextTick(() => {
      if (this.showDemo == 'true') {
        this.owndata = this.avadata
        this.getDataView()
      } else {
        this.owndata = this.simpleavadata
        setTimeout(() => {
          this.getDataView()
        }, 2000)
      }
    })
  },
  methods: {
    getDataView() {
      console.log('[table1/getDataView]');
      // this.axios.get('api/kcapi/get_sexandage').then((response) => {
      console.log(this.owndata)
    },
    resize() {
      //this.$refs['chart'].resize()
    },

    isShow( x, y ){
        //console.log('[isShow]', x, y, x==this.showX && y==this.showY);
        return x==this.showX && y==this.showY;
    },
    isHighlightTd(x,y){
        if(
            (x==1 && [2,3,4,6].indexOf(y)>-1)
            || (x==2 && [2,6].indexOf(y)>-1)
            || (x==3 && y==2) 
        ){
            return 'td_highlight';
        }
        return '';
    },

    chgShowTableItem( x, y ){
        //console.log('[chgShowTableItem]', x, y);
        if(x==this.showX && y==this.showY){
            this.showX = 0;
            this.showY = 0;
        }else{
            this.showX = x;
            this.showY = y;
        }

        setTimeout(() => { this.$emit('chgHeight'); }, 100);

    },

  }
}
</script>

<style>
.table1{width:100%; /*line-height:50px;*/ border:1px solid #dfe0e0; table-layout:fixed; }
.table1 th, .table1 td{ text-align:center; padding:0 8px;}
.table1 thead th{background-color:#d9e7ff;}
.table1 tbody td{ border-right:1px solid #dfdfdf; border-bottom:1px solid #dfdfdf;}
.table1 tbody td:last-child{ border-right:0; }

/*.table1 tbody tr:nth-of-type(even) td{ background-color:#f2f3f5; }*/



.table1 .td_normal{ background-color:red; height:40px; }
.table1 .td_normal div{ display:none1; min-height:40px;  }

.table1 .tr_0  td.td_normal{ background-color:#FFFF00 }
.table1 .tr_1  td.td_normal{ background-color:#F4B183; }
.table1 .tr_2  td.td_normal{ background-color:#FFE699; }
.table1 .tr_3  td.td_normal{ background-color:#C5E0B4; }
.table1 .tr_4  td.td_normal{ background-color:#FFFFFF; }

.table1 td.td_highlight{ background-color:#FFFF00!important; }




.table2{ border-collapse: collapse; }
.table2 td{ width:50px;padding:0 5px; height:30px; }

</style>
